<template>
  <div class="custom--section h100 overflow-x-y">
    <div class="section--body">
      <!--<tabs v-model="clientType" :props-data="tabList" @tab-click="handleTabClick" />-->
      <el-radio-group v-model="clientType" size="small" class="ml-5 tree-tabs-wrapper">
        <el-radio-button label="WEB"></el-radio-button>
        <el-radio-button label="APP"></el-radio-button>
      </el-radio-group>
      <el-table
        :data="showMenuData"
        class="table_body"
        row-key="id"
        height="calc(100% - 60px)"
        :row-style="{ height: '24' }"
        :cell-style="{ padding: '0' }"
        border
        :expand-row-keys="expandRowKeys"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        @expand-change="expandChange"
      >
        <el-table-column
          prop="menuName"
          label="菜单名称"
          :show-overflow-tooltip="true"
          width="200px"
          :resizable="false"
        >
          <template slot-scope="scope">
            <div class="ellipsisWarp">
              <span>{{ scope.row.menuName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="menuPath"
          :show-overflow-tooltip="true"
          label="路由地址(Href)"
          min-width="200px"
          :resizable="false"
        >
          <template slot-scope="scope">
            <div class="ellipsisWarp">
              <span>{{ scope.row.menuPath }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          label="排序(升序)"
          width="90px"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="menuCode"
          :show-overflow-tooltip="true"
          label="菜单编码"
          width="150px"
          :resizable="false"
        >
          <template slot-scope="scope">
            <div class="ellipsisWarp">
              <span>{{ scope.row.menuCode }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="permission" label="权限标识"></el-table-column> -->
        <el-table-column prop="menuType" width="80px" label="菜单类型" :resizable="false">
          <template slot-scope="scope">
            <el-tag
              style="height: 28px; line-height: 26px"
              :type="
                scope.row.menuType === 'MENU'
                  ? 'success'
                  : scope.row.menuType === 'BUTTON'
                    ? 'warning'
                    : 'danger'
              "
            >
              {{ changeMenuTypeToText(scope.row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="menuIsSys"
          label="菜单分类"
          width="150px"
          :resizable="false"
          :formatter="isSysFormatter"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div class="ellipsisWarp">
              <span>{{ scope.row.menuCode }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="effect"
          label="是否有效"
          width="80px"
        >
          <template slot-scope="scope">
            <div class="effect-content">
              <el-switch
                v-if="scope.$index"
                v-model="scope.row.effect"
                :active-value= true
                :inactive-value= false
                active-icon-class="el-icon-check"
                @change="changeSwitch(scope.row)"
              ></el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="200" style="padding-left: 24px">
          <template slot-scope="scope">
            <div class="button--view">
              <el-button
                v-if="isSystem || isTenant ? true : visibleResource('menu_add_submenu_button')"
                style="padding-right: 8px"
                type="text"
                class="cursor-p"
                :class="initAddClass(scope.row)"
                @click="scope.row.isApplaticon ? addMenu(scope.row) : addChildMenu(scope.row)"
              >
                {{ isSystem || isTenant ? '添加子菜单' : getLabel('menu_add_submenu_button') }}
              </el-button>
              <el-button
                v-if="scope.$index && (isSystem || isTenant ? true : visibleResource('menu_edit_button'))"
                style="padding-right: 8px"
                type="text"
                class="cursor-p"
                :disabled="scope.row.id === '123'"
                :class="initEditClass(scope.row)"
                @click="editMenu(scope.row)"
              >
                {{ isSystem || isTenant ? '编辑' : getLabel('menu_edit_button') }}
              </el-button>
              <el-button
                v-if="scope.$index
                  && (isSystem || isTenant
                    ? true
                    : visibleResource('menu_delete_button'))
                "
                type="text"
                class="cursor-p"
                :disabled="scope.row.id === '123'"
                :class="initDeleteClass(scope.row)"
                @click="deleteMenu(scope.row)"
              >
                {{ isSystem || isTenant ? '删除' : getLabel('menu_delete_button') }}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新增修改弹框 -->
    <menu-detail
      :visible.sync="dialogVisible"
      :oper-type="operType"
      :client-type="clientType"
      :dialog-data="dialogData"
      :title="menuTitle"
      @success="addSuccess"
    />

    <!-- 删除弹窗 -->
    <delete-dialog
      layout="left"
      :visible.sync="deleteDialogVisible"
      :content="deleteContent"
      :loading.sync="deleteLoading"
      @confirm="handleDeleteConfirm"
    />
  </div>
</template>

<script>
import menuApi from "@/api/menu/menu";
import Tabs from "@/components/common/Tabs/tabs";
import MenuDetail from "./menu-detail.vue";
import DeleteDialog from "@/components/common/Dialogs/DeleteDialog";
import { mapGetters } from "vuex";
import { schemaMixins } from "@/mixin/schema";

export default {
  name: "MenuConfig",
  components: {
    MenuDetail,
    DeleteDialog,
    Tabs
  },
  mixins: [schemaMixins],
  props: {
    isSys: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      resourceCode: "menu-list",
      /*tabList: [
          {
            name: 'WEB',
            label: 'WEB端功能权限'
          },
          {
            name: 'APP',
            label: 'APP端功能权限'
          }
        ],*/
      loading: false,
      customRoleIds: [],
      defaultCheckedKeys: [],
      menuTitle: "",
      dialogVisible: false,
      dialogData: {},
      operType: "",
      clientType: "WEB",

      showMenuData: [],
      deleteDialogVisible: false,
      deleteLoading: false,
      deleteItem: {},
      deleteContent: {
        title: "确定要删除此条数据吗？",
        description: "删除后不可恢复,请谨慎操作"
      },
      expandRowKeys: ["-1"]
    };
  },
  watch: {
    clientType() {
      this.getMenuTree();
    }
  },
  computed: {
    ...mapGetters(["isSystem", "isTenant"])

  },
  mounted() {
    this.getMenuTree();
  },
  methods: {
    expandChange(row, expanded) {
      if (expanded) {
        this.expandRowKeys.push(row.id);
        return;
      }

      this.expandRowKeys.splice(
        this.expandRowKeys.findIndex(id => id === row.id),
        1
      );
    },

    /**
       * @description: 菜单类型转换文字
       * @param {*} item
       * @return {*}
       */
    changeMenuTypeToText(item) {
      const menuTypeText =
        item.menuType === "MENU" ? "菜单" : item.menuType === "BUTTON" ? "按钮" : "目录";
      return menuTypeText;
    },

    /**
       * @description:初始化删除按钮样式，有子节点显示灰色 非超级管理员不能操作
       * @param {*}
       * @return {*}
       */
    initDeleteClass(item) {
      if (item.children !== null || (!this.isSystem && item.systemDefault)) {
        return "";
      }
      return "colorRed";
    },

    /**
       * @description:初始化添加按钮样式，按钮类型不能添加  非超级管理员不能操作（除第一行）
       * @param {*} item
       * @return {*}
       */
    initAddClass(item) {
      if (!item.isApplaticon && item.menuType === "BUTTON") {
        return "";
      }
      return "colorGreen";
    },

    /**
       * @description:初始化编辑按钮样式，前端添加的isApplation一行不允许编辑 非超级管理员不能操作 非超管自定义可以操作
       * @param {*} item
       * @return {*}
       */
    initEditClass(item) {
      if (item.isApplaticon || (!this.isSystem && item.systemDefault)) {
        return "";
      }
      return "colorGreen";
    },

    /**
       * @description: 获取全量菜单
       * @param {*}
       * @return {*}
       */
    getMenuTree() {
      this.loading = true;
      this.showMenuData = [
        {
          clientType: this.clientType,
          menuName: "根节点",
          menuType: "DIRECTORY",
          isApplaticon: true,
          id: "-1",
          children: [],
          systemDefault: true
        }
      ];
      menuApi.getList({ parseToTree: true, clientType: this.clientType }).then(res => {
        this.loading = false;
        this.showMenuData[0].children = res.data;
      });
    },

    /**
       * @description: 添加菜单成功
       * @param {*}
       * @return {*}
       */
    addSuccess() {
      this.dialogData = {};
      this.dialogVisible = false;
      this.getMenuTree();
    },

    /**
       * @description: 点击取消
       * @param {*}
       * @return {*}
       */
    cancelDialog() {
      this.dialogData = {};
      this.dialogVisible = false;
    },

    /**
       * @description: web、app切换
       * @param {*} tab
       * @param {*} event
       * @return {*}
       */
    /*handleTabClick(tab, event) {
        // const checkChange = this.$refs.webTree.getCheckChange();
        this.clientType = tab.name;
        this.getMenuTree();
      },*/

    /**
       * @description: 添加一级菜单
       * @param {*}item，菜单数据
       * @return {*}
       */
    addMenu(item) {
      this.menuTitle = `添加子菜单(${this.clientType})`;
      this.operType = "new";
      this.dialogData = item;
      this.dialogVisible = true;
    },

    changeSwitch(item) {
      const param = { effect: item.effect, id: item.id };
      menuApi
        .editMenu(param)
        .then(res => {
          this.$message({
            message: "编辑成功",
            type: "success",
            duration: 5 * 1000
          });
        })
        .catch(() => {
        });
    },

    /**
       * @description: 编辑某个菜单
       * @param {*} item，菜单数据
       * @return {*}
       */
    editMenu(item) {
      this.menuTitle = `编辑菜单(${this.clientType})`;
      this.operType = "edit";
      this.dialogData = item;
      this.dialogVisible = true;
    },

    /**
       * @description: 删除某个菜单
       * @param {*} item，item，菜单数据
       * @return {*}
       */
    deleteMenu(item) {
      this.deleteItem = item;
      const text = item.children ? "以及它的子菜单" : "";
      this.deleteContent.title = `确定要删除"${item.menuName}"${text}吗？`;
      this.deleteLoading = false;
      this.deleteDialogVisible = true;
    },

    /**
       * @description: 添加item的子菜单
       * @param {*} item，父亲菜单数据
       * @return {*}
       */
    addChildMenu(item) {
      this.menuTitle = `添加子菜单(${this.clientType})`;
      this.operType = "add";
      this.dialogData = {};
      this.dialogData.id = item.id;
      this.dialogData.menuName = item.menuName;
      this.dialogData.menuType = item.menuType;
      this.dialogVisible = true;
    },
    // 确认删除
    handleDeleteConfirm() {
      this.deleteLoading = true;
      menuApi
        .deleteMenuById(this.deleteItem.id)
        .then(res => {
          // 从列表删除数据
          this.deleteDialogVisible = false;
          this.deleteLoading = false;
          this.$message.closeAll();
          this.$message.success("删除成功");
          // this.delItem(this.showMenuData, this.deleteItem);
          this.getMenuTree();
        })
        .catch(() => {
          this.deleteLoading = false;
        });
    },

    /**
       * @description: 删除数组中某个元素
       * @param {*} item
       * @return {*}
       */
    delItem(array, delItem) {
      array.some((item, i) => {
        if (item.id === delItem.id) {
          array.splice(i, 1); // 在数组的some方法中，如果return true，就会立即终止这个数组的后续循环
          return true;
        }
        if (item.children && item.children.length) {
          this.delItem(item.children, delItem);
        }
      });
    },
    // 是否系统数据转换
    isSysFormatter(row) {
      if (row.systemDefault) {
        return "系统级";
      } else {
        return "自定义 ";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .tree-tabs-wrapper{
    margin: 0;
    .el-radio-button {
      margin-top: 0px;
      ::v-deep .el-radio-button__inner {
        padding: 8px 10px!important;
        width: 88px;
        font-size: 12px;
      }
    }
  }

  .effect-content {
    text-align: center;
  }
  .ellipsisWarp {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .custom--section {
    padding: 10px 20px;
    // position: relative;
  }
  .section--header {
    // position: absolute;
    // right: 22px;
    h3,
    span {
      display: inline-block;
      vertical-align: top;
      height: 0px;
      line-height: 40px;
    }
    h3 {
      margin: 0;
    }
    span {
      font-size: 12px;
      margin: 0 0 0 0px;
    }
  }
  .section--body {
    height: 100%;
    margin-top: 10px;
  }

  .allot--footer {
    text-align: right;
    margin-top: 20px;
  }
  .fr {
    float: right;
  }
  .tab-body {
    position: relative;

    .disabled-modal {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(204, 204, 204, 0.01);
      z-index: 2;
    }
    &.disabled {
      ::v-deep .el-checkbox__input .el-checkbox__inner,
      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
      ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #ccc;
        border-color: #ccc;
      }
    }
  }
  .table_body {
    width: 100%;
    margin-bottom: 20px;
    height: 85%;
    margin-top: 15px;
    // overflow-y: scroll;
  }
  .button--view {
    padding-right: 16px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-items: center;
    // justify-content: space-around;

    .text--border {
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
    }
  }
  .colorRed {
    color: red;
  }
  .colorGreen {
    color: $scim-color-primary;
  }
  .el-table .normal-row {
    height: 24px;
    background: #f0f9eb;
    padding: 0px;
  }

  ::v-deep .el-table {
    td,
    th {
      padding: 0;

      & > .cell {
        display: flex;
        align-items: center;
        padding: 0;
        padding-left: 16px;
        line-height: 40px;
        height: 40px;
        overflow: hidden;
      }
    }

    thead {
      color: #21252e !important;
      font-family: PingFangSC, PingFangSC-Medium SourceSans Regular, sans-serif, "Microsoft YaHei",
      微软雅黑;
      font-weight: 500;
      color: #21252e;
      font-size: 14px;
      tr {
        height: 49px;
        th {
          background: #f5f7fa;
        }
      }
      th.is-leaf {
        border-right: 1px solid #ebecef !important;
        border-bottom: 1px solid #d4d9e2 !important;
      }
    }
    td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
      border-bottom: 1px solid #ebecef !important;
      border-right: 1px solid #ebecef !important;
    }
  }
  // .el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed
</style>

